import { OptionSelect } from "components/InputSelect/InputSelect";

export const optionsOrientation: OptionSelect[] = [
    { value: "orientation_circle", label: "Circle" },
    { value: "orientation_cubic", label: "Cubic" },
    { value: "orientation_hexagon", label: "Hexagon" },
    { value: "orientation_horizontal", label: "Horizontal" },
    { value: "orientation_landscape", label: "Landscape" },
    { value: "orientation_pentagon", label: "Pentagon" },
    { value: "orientation_portrait", label: "Portrait" },
    { value: "orientation_square", label: "Square" },
    { value: "orientation_triangle", label: "Triangle" },
    { value: "orientation_verticle", label: "Verticle" },
];

export const optionsCategory: OptionSelect[] = [
    { value: "category_drawings", label: "Drawing" },
    { value: "category_paintings", label: "Painting" },
    { value: "category_photography", label: "Photography" },
    { value: "category_sculptures", label: "Sculpture" },
    { value: "category_serigraphs", label: "Serigraphs" },
];

export const optionsStyle: OptionSelect[] = [
    { value: "style_3D", label: "3d" },
    { value: "style_abstract expressionism", label: "Abstract expressionism" },
    { value: "style_abstraction", label: "Abstraction" },
    { value: "style_art deco", label: "Art deco" },
    { value: "style_art-deco", label: "Art-deco" },
    { value: "style_conceptual", label: "Conceptual" },
    { value: "style_contemporary", label: "Contemporary" },
    { value: "style_couple", label: "Couple" },
    { value: "style_cubism", label: "Cubism" },
    { value: "style_documentary", label: "Documentary" },
    { value: "style_figurative", label: "Figurative" },
    { value: "style_Fine Art", label: "Fine Art" },
    { value: "style_fine-art", label: "Fine-art" },
    { value: "style_folk art", label: "Folk art" },
    { value: "style_hand-art", label: "Hand-art" },
    { value: "style_hyper realism", label: "Hyper realism" },
    { value: "style_illustration", label: "Illustration" },
    { value: "style_impressionism", label: "Impressionism" },
    { value: "style_minimalism", label: "Minimalism" },
    { value: "style_modern", label: "Modern" },
    { value: "style_new-wow", label: "New-wow" },
    { value: "style_photo realism", label: "Photo realism" },
    { value: "style_pop art", label: "Pop art" },
    { value: "style_portrait", label: "Portrait" },
    { value: "style_portraiture", label: "Portraiture" },
    { value: "style_railway", label: "Railway" },
    { value: "style_realism", label: "Realism" },
    { value: "style_street art", label: "Street art" },
    { value: "style_surrealism", label: "Surrealism" },
    { value: "style_symbolism", label: "Symbolism" },
    { value: "style_textured", label: "Textured" },
];

export const optionsSurface: OptionSelect[] = [
    { value: "surface_Acid free paper", label: "Acid free paper" },
    { value: "surface_acrylic board", label: "Acrylic board" },
    { value: "surface_acrylic paper", label: "Acrylic paper" },
    { value: "surface_acrylic sheet", label: "Acrylic sheet" },
    { value: "surface_canson board", label: "Canson board" },
    { value: "surface_canvas", label: "Canvas" },
    { value: "surface_canvas board", label: "Canvas board" },
    { value: "surface_cardboard", label: "Cardboard" },
    { value: "surface_cotton cloth", label: "Cotton cloth" },
    { value: "surface_jute", label: "Jute" },
    { value: "surface_leather", label: "Leather" },
    { value: "surface_linen", label: "Linen" },
    { value: "surface_mountboard", label: "Mountboard" },
    { value: "surface_oil paper", label: "Oil paper" },
    { value: "surface_paper", label: "Paper" },
    { value: "surface_plywood", label: "Plywood" },
    { value: "surface_rice paper", label: "Rice paper" },
    { value: "surface_silk", label: "Silk" },
    { value: "surface_stretched canvas", label: "Stretched canvas" },
    { value: "surface_synthic Bond", label: "Synthic Bond" },
    { value: "surface_wood", label: "Wood" },
];

export const optionsMedium: OptionSelect[] = [
    { value: "medium_acrylic", label: "Acrylic" },
    { value: "medium_batik", label: "Batik" },
    { value: "medium_charcoal", label: "Charcoal" },
    { value: "medium_coffee", label: "Coffee" },
    { value: "medium_color pencils", label: "Color pencils" },
    { value: "medium_drawing", label: "Drawing" },
    { value: "medium_gold", label: "Gold" },
    { value: "medium_graphite", label: "Graphite" },
    { value: "medium_ink", label: "Ink" },
    { value: "medium_leather", label: "Leather" },
    { value: "medium_link", label: "Link" },
    { value: "medium_mix media", label: "Mix media" },
    { value: "medium_natural color", label: "Natural color" },
    { value: "medium_new", label: "New" },
    { value: "medium_oil", label: "Oil" },
    { value: "medium_painting", label: "Painting" },
    { value: "medium_pastel", label: "Pastel" },
    { value: "medium_pencil", label: "Pencil" },
    { value: "medium_Sellotape", label: "Sellotape" },
    { value: "medium_spray paint", label: "Spray paint" },
    { value: "medium_tempera", label: "Tempera" },
    { value: "medium_watercolor", label: "Watercolor" },
    { value: "medium_wax", label: "Wax" },
    { value: "medium_wood cut", label: "Wood cut" },
    { value: "medium_wow", label: "Wow" },
];

export const optionsSize: OptionSelect[] = [
    { value: "size_extra-large", label: "Extra large" },
    { value: "size_large", label: "Large" },
    { value: "size_medium", label: "Medium" },
    { value: "size_small", label: "Small" },
];
